module.exports = __webpack_public_path__ + "img/phone-todo-2.2c5c3de0.png";